import * as types from './types';

export const getLeadsStatuses = () => {
  return {
    type: types.GET_LEADS_STATUSES,
  };
};

export const createLeadsStatus = (variables) => {
  return {
    type: types.CREATE_LEADS_STATUS,
    payload: variables,
  };
};

export const updateCustomStatus = (variables) => {
  return {
    type: types.UPDATE_CUSTOM_STATUS,
    payload: variables,
  };
};

export const deleteCustomStatus = (variables) => {
  return {
    type: types.DELETE_CUSTOM_STATUS,
    payload: variables,
  };
};

export const reorderStatuses = (variables) => {
  return {
    type: types.REORDER_LEADS_STATUSES,
    payload: variables,
  };
};

// Default Assignments
export const setDefaultAssignment = (payload) => {
  return {
    type: types.SET_DEFAULT_ASSIGNMENT,
    payload,
  };
};

export const unsetDefaultAssignment = (payload) => {
  return {
    type: types.UNSET_DEFAULT_ASSIGNMENT,
    payload,
  };
};

// Incoming Notifications
export const addLeadContact = (payload) => {
  return {
    type: types.ADD_LEAD_CONTACT,
    payload,
  };
};

export const deleteLeadContact = (payload) => {
  return {
    type: types.DELETE_LEAD_CONTACT,
    payload,
  };
};
